import {
  Radio as MantineRadio,
  RadioGroupProps as MantineRadioGroupProps,
  RadioProps as MantineRadioProps
} from "@mantine/core";
import {forwardRef} from "react";

export type RadioProps = MantineRadioProps & {
  // extend props here
}

export const Radio = forwardRef<HTMLInputElement, RadioProps>((props, ref) => {
  const {...rest} = props;
  return <MantineRadio ref={ref} {...rest} />;
});

export type RadioGroupProps = MantineRadioGroupProps
export const RadioGroup = MantineRadio.Group;
